import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ListFilters} from '../../tools/list-filters/list-filters';
import {Paginator} from '../../tools/pagination/paginator';
import {SnackbarService} from '../snackbar/snackbar.service';
import {ListFilterType} from '../../types/list-filter-type';
import {UserActivityService} from '../user-activity/user-activity.service';
import {TableSorter} from '../../tools/table-sorter/table-sorter';

@Injectable({
  providedIn: 'root'
})
export class ListFilterService {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snackbar: SnackbarService,
    private userActivity: UserActivityService,
  ) {
  }

  createFilters(
    definitions: { [name: string]: ListFilterType },
    paginator: Paginator | null = null,
    tableSorter: TableSorter | null = null,
    reportActivity: boolean = true,
  ): ListFilters {
    return new ListFilters(definitions, paginator, tableSorter, this.route, this.router, this.snackbar,
      reportActivity ? this.userActivity : null);
  }
}
